import { BUTTON_TYPES } from '../../../components/Button'
import { BTN_TXT } from '../../../constants'
import Button from '../../../components/Button/Button'
import { useCallback } from 'react'
import { ReactComponent as FilterApplied16 } from '../../../assets/svg/FilterApplied16.svg'
import { ReactComponent as Filter16 } from '../../../assets/svg/Filter16.svg'
import { useDashboardPopup } from '../Providers/DashboardPopupProvider'
import { useDashboardFilterContext } from '../Providers/DashboardFilterContendProvider'

export const FiltersButton = () => {
  const {
    state: { filtersApplied, hideFilter }
  } = useDashboardFilterContext()

  const { filtersPopup } = useDashboardPopup()

  const onClick = useCallback(() => {
    filtersPopup.actions.open()
  }, [filtersPopup])

  if (hideFilter) return null

  return (
    <Button
      type={BUTTON_TYPES.DEFAULT}
      onClick={onClick}
      upperCase
      icon={filtersApplied ? <FilterApplied16 /> : <Filter16 />}
    >
      {BTN_TXT.FILTERS}
    </Button>
  )
}
